<template>
  <v-container fluid class="ma-0 pa-0">
    <Header :role="role" :authorities="authorities" :streamData="streamData" />
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
      <v-col class="ma-0 pa-1 pt-7 mb-7" cols="12">
        <v-col class="ma-0 pa-0 text-left" cols="12">{{tmb('msgVideoDownload')}}</v-col>
        <v-col class="ma-0 pa-0 text-left" cols="12">{{tmb('until100hour')}}</v-col>
        <v-col id="download_info_box" class="ma-0 pa-0 mt-2 mb-6" cols="12">
          <v-col class="ma-0 pa-4 text-left" cols="12">{{tmb('createDownloadFile')}}</v-col>
          <v-divider id="middle_divider" class="ma-0 pa-0"></v-divider>
          <v-col class="ma-0 pa-4 pl-7 pr-7" cols="12">
            <v-row class="ma-0 pa-0" align="center">
              <v-col class="ma-0 pa-0 text-left" cols="auto">{{tmb('remainTime')}}</v-col>
              <v-col class="ma-0 pa-0 pl-2 text-left" cols="auto">{{remainingTimeStr}}</v-col>
            </v-row>
            <v-row class="ma-0 pa-0" align="center">
              <v-col class="ma-0 pa-0 text-left" cols="auto">{{tmb('totalTime')}}</v-col>
              <v-col class="ma-0 pa-0 pl-2 text-left" cols="auto">{{usedTimeStr}}</v-col>
            </v-row>
            <v-col class="ma-0 pa-0 mt-7 text-left" cols="12">{{tmb('durationTime')}}</v-col>
            <v-row class="ma-0 pa-0 mt-1" align="center">
              <v-col class="ma-0 pa-0 pl-4 text-left" cols="auto">{{'開始日時：'}}</v-col>
              <v-col class="ma-0 pa-0 mr-2" cols="2">
                <CustomDatePicker :viewCalendarIcon="false" :viewTextField="true"
                                  :initDate="false" :time="false" :disableFuture="true"
                                  :fontSize="'1rem'" :recordingCkeck="true" :recordingPeriod="recordingPeriod"
                                  @resultDate="startDateFunc" />
              </v-col>
              <v-col class="ma-0 pa-0" cols="auto" style="width:5rem;">
                <v-select background-color="#272727" dark
                          v-model="selectedHour"
                          :items="hourList" dense hide-details outlined
                          item-text="label" item-value="value"
                ></v-select>
              </v-col>
              <v-col class="ma-0 pa-0" cols="auto">{{'：'}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto" style="width:5rem;">
                <v-select background-color="#272727" dark
                          v-model="selectedMinute"
                          :items="minuteList2" dense hide-details outlined
                          item-text="label" item-value="value"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 mt-1" align="center">
              <v-col class="ma-0 pa-0 pl-4 text-left" cols="auto">{{'録画時間：'}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
                <v-select background-color="#272727" dark
                          v-model="selectedDownloadMinute"
                          :items="minuteList" dense hide-details outlined
                          item-text="label" item-value="value"
                ></v-select>
              </v-col>
            </v-row>
            <v-col class="ma-0 pa-0 mt-7 text-left" cols="12">{{tmb('msgDataName')}}</v-col>
            <v-col class="ma-0 pa-0 mt-2 text-left" cols="12">
              <v-row class="ma-0 pa-0" align="center">
                <v-col class="ma-0 pa-0 text-left" cols="8">
                  <input class="name_input"
                         style="width:80%;height:2.5rem;" v-model="userInputDataName" @input="validateMaxInput">
                  <div class="error-message" v-show="showMaxError">{{ tmb('msgErrorMaxCharacters') }}</div>
                  <div class="error-message" v-show="showInvalidCharacter">{{ tmb('msgErrorFileName') }}</div>
                </v-col>
                <v-col class="ma-0 pa-0 text-right" cols="4">
                  <v-btn width="8rem" height="auto" class="ma-0 pa-2"
                         id="blue_btn" elevation="0" @click="confirmFunc">
                    {{t('create')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-col>
        </v-col>
        <v-col class="ma-0 pa-0 mb-2 text-left" cols="12">{{tmb('msgDownloadFileList')}}</v-col>
        <v-col id="table_header" class="ma-0 pa-2" cols="12">
          <v-row class="ma-0 pa-0" align="center">
            <v-col class="ma-0 pa-0 text-left" cols="4">{{tmb('titleDownloadFile')}}</v-col>
            <v-col class="ma-0 pa-0 text-left" cols="4">{{tmb('titleDurationTime')}}</v-col>
            <v-col class="ma-0 pa-0 text-left" cols="4">{{tmb('titleDurationPreserve')}}</v-col>
          </v-row>
        </v-col>
        <v-col id="table_body" class="ma-0 pa-0" cols="12">
          <template v-if="downloadDataList.length > 0">
            <v-col class="ma-0 pa-0" cols="12"
                   v-for="(item, index) in downloadDataList" :key="index">
              <DownloadDataListItem :item="item" @deleteSuccess="deleteSuccessFunc" />
            </v-col>
          </template>
          <!-- 타이틀 아래가 공란이기 때문에 굳이 '데이터 없음' 표시 안함 -->
          <!-- <template v-else>
            <v-col class="ma-0 pa-15" cols="12">{{t('noData')}}</v-col>
          </template> -->
        </v-col>
      </v-col>
    </v-col>
    <DownloadConfirmDialog :dialogVisible="downloadConfirmDialogVisible" :params="params"
                           :streamData="streamData" :downloadTime="selectedDownloadMinute"
                           :dataName="userInputDataName"
                           @visible="downloadConfirmDialogVisibleFunc" @success="successFunc" />
  </v-container>
</template>

<script>
import mixin from '@/mixin';
import Header from '@/views/player/components/Header.vue';
import DownloadDataListItem from '@/views/player/components/DownloadDataListItem.vue';
import DownloadConfirmDialog from '@/views/player/components/dialog/DownloadConfirmDialog.vue';
import { isEmpty } from 'lodash';
import CustomDatePicker from '@/components/DatePicker.vue';
import {PICKER_HOUR_OPTION, PICKER_DOWNLOAD_DURATION_MINS, PICKER_MINUTE_ONLY_VALUE_OPTION} from '@/constants';
import * as dayjs from 'dayjs'
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
dayjs.extend(isSameOrAfter);
export default {
  components: {
    CustomDatePicker,
    DownloadConfirmDialog,
    DownloadDataListItem,
    Header
  },
  mixins: [mixin.common],
  data: () => ({
    downloadConfirmDialogVisible: false,
    authorities: {},
    role: '',
    streamData: {},
    recordingPeriod: 7,
    remainingTimeStr: '100時間00分00秒',
    usedTimeStr: '00時間00分00秒',
    startDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
    hourList: PICKER_HOUR_OPTION,
    minuteList: PICKER_DOWNLOAD_DURATION_MINS,
    minuteList2: PICKER_MINUTE_ONLY_VALUE_OPTION,
    selectedHour: '00',
    selectedMinute: '00',
    selectedDownloadMinute: '30',
    userInputDataName: '',
    params: {},
    showMaxError: false, // 경고 메시지를 보여줄지 여부를 제어하는 데이터
    showInvalidCharacter: false, // 경고 메시지를 보여줄지 여부를 제어하는 데이터
    downloadDataList: [],
    fetchInterval: null,
    refreshTrigger: false,
  }),
  watch: {
    startDate: function(item) {
      this.checkFuture();
    },
    selectedHour: function(item) {
      this.checkFuture();
    },
    selectedMinute: function(item) {
      this.checkFuture();
    },
    selectedDownloadMinute: function(item) {
      this.checkFuture();
    },
    refreshTrigger: function(item) {
      if(item) {
        if(this.fetchInterval === null) {
          this.fetchInterval = setInterval(() => {
            this.fetchDownloadVideoList();
          }, 60000) // 1분마다 갱신
        }
      } else {
        clearInterval(this.fetchInterval);
        this.fetchInterval = null;
      }
    }
  },
  created() {
    this.authorities = this.$store.getters.getAuthorities;
    this.role = this.roleCheck(this.$store.getters.getRole);
  },
  mounted() {
    this.streamData = this.$store.getters.getStreamInfo;
    this.fetchRecordingPeriod();
    this.fetchDownloadVideoList();
  },
  beforeDestroy() {
    clearInterval(this.fetchInterval);
    this.fetchInterval = null;
  },
  methods: {
    downloadConfirmDialogVisibleFunc(visible) {
      this.downloadConfirmDialogVisible = visible;
    },
    confirmFunc() {
      this.generateDataName(); // for test
      this.downloadConfirmDialogVisible = true;
      this.requestCreateRecodedVideo();
    },
    fetchRecordingPeriod() {
      this.networkController.getCameraRecordingPeriod({}, this.streamData.contractCd)
        .then(async (res) => {
          console.log('%crecording peroid\n', "color:#008DD0;", res.data);
          this.recordingPeriod = res.data.recordingPeriod;
        }).catch(error => { });
    },
    fetchDownloadVideoList() {
      // this.fetchLoading = true;
      this.networkController.getRecodedVideoList({}, this.streamData.contractCd, this.streamData.portNo).then((res) => {
        console.log('%cFetch Recorded Video List\n', 'color:#008DD0;', res.data);
        // this.fetchLoading = false;
        this.remainingTimeStr = this.calRemainingTime(res.data.curMonthUsedTime);
        this.usedTimeStr = this.calUsedTime(res.data.curMonthUsedTime);
        this.downloadDataList = res.data.recordedVideoList;
        this.refreshTrigger = this.checkRefreshVideoList(res.data.recordedVideoList);
      }).catch(error => {
        // this.fetchLoading = false;
      });
    },
    // 입력한 데이터명이 없을 경우 default file명의 설정
    generateDataName() {
      if (!isEmpty(this.userInputDataName)) return;

      const today = new Date();
      const yyyy = today.getFullYear().toString();
      const mm = (today.getMonth() + 1).toString().padStart(2, '0');
      const dd = today.getDate().toString().padStart(2, '0');
      const hh = today.getHours().toString().padStart(2, '0');
      const min = today.getMinutes().toString().padStart(2, '0');
      const ss = today.getSeconds().toString().padStart(2, '0');

      // "yyyy-mm-dd_hhmmss" 형식으로 데이터명을 생성
      this.userInputDataName = `${yyyy}-${mm}-${dd}_${hh}${min}${ss}`;
    },
    validateMaxInput() {
      if (this.userInputDataName.length > 30) {
        // 30자를 초과하는 경우, 입력을 30자까지.
        this.userInputDataName = this.userInputDataName.slice(0, 30);
        // showErrorMessage를 true로 설정하여 경고 메시지
        this.showMaxError = true;
      } else {
        // 30자 이하인 경우, 경고 메시지를 숨기기
        this.showMaxError = false;
      }
      // check invalid character for file name
      const invalidCharacter = /[\\/:*?"<>|]/;
      if (invalidCharacter.test(this.userInputDataName)) {
        this.showInvalidCharacter = true;
      } else {
        this.showInvalidCharacter = false;
      }
    },
    startDateFunc(date) {
      this.startDate = date;
    },
    successFunc(value) {
      this.fetchDownloadVideoList();
      this.userInputDataName = '';
    },
    requestCreateRecodedVideo() {
      const begin = dayjs( this.startDate.substring(0, 10) + 'T' + this.selectedHour + ':' + this.selectedMinute + ':00')
      const end = dayjs( this.startDate.substring(0, 10) + 'T' + this.selectedHour + ':' + this.selectedMinute + ':00')
      this.params = {
        name: this.userInputDataName,
        beginTime: begin.format("YYYY-MM-DDTHH:mm:ss.SSS"),
        endingTime: end.add(Number(this.selectedDownloadMinute), 'minute').format("YYYY-MM-DDTHH:mm:ss.SSS")
      }
    },
    calRemainingTime(seconds) {
      const hTime = 360000 - seconds;
      const hours = Math.floor(hTime / 3600);
      const minutes = Math.floor((hTime % 3600) / 60);
      const remainingSeconds = hTime % 60;

      return `${hours}時間${minutes < 10 ? '0' : ''}${minutes}分${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}秒`;
    },
    calUsedTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;

      return `${hours}時間${minutes < 10 ? '0' : ''}${minutes}分${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}秒`;
    },
    checkRefreshVideoList(list) {
      // true false 로 반환, COMPLETED가 아닌 값이 있으면 true로 반환
      return list.some(item => item.status !== 'COMPLETED');
    },
    checkFuture() {
      // result, result2가 true 값이면 미래
      const begin = dayjs( this.startDate.substring(0, 10) + 'T' + this.selectedHour + ':' + this.selectedMinute + ':00')
      const end = begin.add(Number(this.selectedDownloadMinute), 'minute').format("YYYY-MM-DDTHH:mm")
      const current = dayjs(new Date()).format("YYYY-MM-DDTHH:mm");
      const result = begin.isAfter(current);
      const result2 = dayjs(end).isAfter(current);
      if(result || result2) {
        this.selectedHour = '00';
        this.selectedMinute = '00';
        this.showToastMessage(this.tmb('downloadNotFuture'));
        setTimeout(() => {
          this.selectedDownloadMinute = '10';
        }, 250);
      }
    },
    deleteSuccessFunc(status) {
      this.fetchDownloadVideoList();
    },
  }
}
</script>

<style lang="scss" scoped>
/* #main_content_maxwidthset {
  font-weight: bold;
} */
#download_info_box {
  border-radius: 10px;
  background-color: #464646;
}
#middle_divider {
  background-color: #c5c5c5;
}
#blue_btn {
  border-radius: 14px;
  /* font-weight: bold; */
}
.name_input {
  background-color: #eaeaea;
  border: 1px solid #4A4A4A;
  border-radius: 8px;
  color: #535353;
  padding: 5px;
}
#table_header {
  background-color: #464646;
}
.error-message {
  color: #db7093
}
.v-list{
  background: #171921;
  border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    min-height: 0;
    color: white !important;
  }
  .v-list-item__content{
    color: white;
    padding: 5px 0;
  }
  // Select box v화살표 위치
  .v-input__slot {
    padding-right: 2px !important;
  }
  .v-input__append-inner {
    margin-top: 16px !important;
    padding-left: 0 !important;
  }
}
</style>